export enum DistanceUnits {
  ml = 'mi',
  km = 'km',
}
